<template>
  <el-dialog
    v-el-drag-dialog
    no="dialog"
    :visible.sync="innerVisible"
    :title="title"
    width="1275px"
    :close-on-click-modal="false"
    class="billing-dialog"
  >
    <div class="app-main-content" style="height: 100%;">
      <div class="details-view">
        <div class="main-content">
          <div class="tabs-container">
            <el-tabs
              ref="tabs"
              v-model="activeTabName"
              type="card"
              style="width: 100%;"
              @tab-click="handleTabClick"
            >
              <!--出口操作-小票-->
              <el-tab-pane
                v-if="!currentRow.masterFlag"
                :key="1"
                no="basicTab"
                :lazy="true"
                name="basicTab"
                :label="$t('SeaExport.Basic')"
              >
                <basic-tab ref="basicTab" :context="context" action="look" />
              </el-tab-pane>
              <!--出口操作-主票-->
              <el-tab-pane
                v-if="currentRow.masterFlag"
                :key="2"
                no="masterBasicTab"
                :lazy="true"
                name="masterBasicTab"
                :label="$t('SeaExport.Basic')"
              >
                <master-basic-tab ref="masterBasicTab" :context="context" action="look" />
              </el-tab-pane>
              <el-tab-pane
                v-if="docType === 'MAWB' && (currentRow.masterFlag || currentRow.operateType === 2 || currentRow.operateType === 3) || docType === 'HAWB'"
                :key="3"
                no="tabMAWB"
                :lazy="true"
                name="tabMAWB"
                label="MAWB"
              >
                <tab-mawb ref="tabMAWB" :context="context" action="edit" style="width: 1515px;" />
              </el-tab-pane>
              <el-tab-pane
                v-if="docType === 'HAWB'"
                :key="4"
                no="tabHAWB"
                :lazy="true"
                name="tabHAWB"
                label="HAWB"
              >
                <tab-hawb ref="tabHAWB" :context="context" action="edit" style="width: 1515px;" />
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" style="display: flex;">
      <el-button no="preprint" type="primary" @click="printHandler(true)">{{ $t('queryJob.preprint') }}</el-button>
      <el-button
        v-permission="['button_AERouteCentral_BillingPrint']"
        no="print"
        :disabled="!btnEnabled.print"
        type="primary"
        @click="printHandler()"
      >{{ $t('Payment.print') }}</el-button>
      <el-button
        v-show="$store.getters.isAdmin"
        no="undoPrinting"
        :disabled="!btnEnabled.rollbackPrint"
        type="primary"
        @click="rollbackPrintHandler"
      >{{ $t('queryJob.undoPrinting') }}</el-button>
      <span style="line-height: 30px;color: blue;margin-left: 10px;">{{ state }}</span>
      <div style="flex-grow: 1;" />
      <el-button
        no="tempSave"
        :disabled="!btnEnabled.tempSave"
        type="primary"
        @click="saveHandler"
      >{{ $t('queryJob.temporaryStorage') }}</el-button>
      <el-button
        no="save"
        :disabled="!btnEnabled.save"
        type="primary"
        @click="commitHandler"
      >{{ btnSaveLable }}</el-button>
      <el-button no="cancel" @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </span>
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
  </el-dialog>
</template>

<script>
import { BookingWorkspaceContext } from '@/views/cargo/v0/AirExport/components/AeBooking/bookingWorkspaceContext'
import { BookingWorkspacePM } from '@/views/cargo/v0/AirExport/components/AeBooking/bookingWorkspacePM'
import basicTab from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabGeneral'
import masterBasicTab from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabMaster'
import tabMawb from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabMAWB'
import tabHawb from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabHAWB'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { deepCopy } from '@/utils/commonUtil'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { StimulSoftUtil } from '@/class/cargo/model/utils/StimulSoftUtil'
import { PrintTemplateManager } from '@/class/cargo/model/utils/PrintTemplateManager'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import { updateAirCargoDoc } from '@/api/AirExport/airCargoDoc'

export default {
  name: 'BillingDialog',
  components: { basicTab, masterBasicTab, tabMawb, tabHawb, cargoTemplateSelectorDialog },
  props: {
    visible: { type: Boolean, required: true },
    job: { type: Object, required: true },
    showBasic: { type: Boolean, required: false, default: false },
    docType: { type: String, required: true }
  },
  data() {
    return {
      innerVisible: this.visible,
      loading: null,
      title: '',
      context: new BookingWorkspaceContext(),
      pm: new BookingWorkspacePM(this),
      currentRow: {},
      state: '',
      pendTabSet: new Set(),
      activeTabName: '',
      btnEnabled: {
        print: false,
        rollbackPrint: false,
        tempSave: false,
        save: false
      },
      btnSaveLable: this.$t('Payment.submit'),
      saveType: 0,
      templateSelectorDialog: {
        visible: false,
        ctx: null,
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.title = this.docType === CargoDocConsts.HAWB ? this.$t('queryJob.prefabricationOrderSplitting') : this.$t('queryJob.prefabricatedMasterOrder')
        this.activeTabName = ''
        this.onShow()
      }
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    async onShow() {
      if (!this.showBasic) {
        if (this.docType === 'MAWB' && (this.job.masterFlag || this.job.operateType === 2 || this.job.operateType === 3)) {
          this.activeTabName = 'tabMAWB'
        } else if (this.docType === 'HAWB') {
          this.activeTabName = 'tabHAWB'
        }
      }
      // 默认进入基本页签 防止其他页签填完数据在进入基本页签被清除数据
      if (!this.activeTabName) {
        this.activeTabName = this.job.masterFlag ? 'masterBasicTab' : 'basicTab'
      }
      const newJob = deepCopy(this.job) // 复制一个新对象，避免影响原始数据
      this.loading = getLoading4Cxt(this)
      try {
        await Promise.all([
          this.context.prepareData(),
          new AirExportJob(newJob).loadJobRelated({
            job: true,
            lclSlaves: this.currentRow.masterFlag,
            charges: true,
            warehouseIn: this.currentRow.masterFlag,
            warehouseInfo: true,
            trucking: true,
            lclMaster: !this.currentRow.masterFlag,
            airCargoDoc: true,
            containerUsages: true,
            containers: true
          })
        ])
      } finally {
        this.loading.close()
      }
      this.currentRow = newJob
      this.pendTabSet.clear()
      this.handleTabClick()
      this.updateButtonState()
    },
    // tab页签切换
    handleTabClick() {
      this.$nextTick(() => {
        const oldSize = this.pendTabSet.size
        this.pendTabSet.add(this.activeTabName)
        const isRefresh = this.pendTabSet.size > oldSize
        this.$refs[this.activeTabName].onShow(this.currentRow, isRefresh)
      })
    },
    async updateButtonState() {
      const cargoDoc = await new AirExportJob(this.currentRow).getCargoDoc(this.docType, false)
      if (cargoDoc) {
        this.btnEnabled.print = cargoDoc.state === 5
        this.btnEnabled.rollbackPrint = cargoDoc.state === 3
        this.btnEnabled.tempSave = cargoDoc.state < 3
        this.btnEnabled.save = cargoDoc.state < 3 || cargoDoc.state === 5
        this.btnSaveLable = cargoDoc.state === 5 ? this.$t('AirExport.CancelSubmission') : this.$t('Payment.submit')
        switch (cargoDoc.state) {
          case 0:
          case 1:
          case 2:
            this.state = this.$t('CargoMsg.Cargo_PositiveOperation')
            break
          case 3:
            this.state = this.$t('Message.Locked')
            break
          case 4:
            this.state = this.$t('Message.Confirmed')
            break
          case 5:
            this.state = this.$t('Message.Submitted')
            break
          default:
            break
        }
      } else {
        this.btnEnabled.print = false
        this.btnEnabled.rollbackPrint = false
        this.btnEnabled.tempSave = false
        this.btnEnabled.save = false
        this.btnSaveLable = this.$t('Payment.submit')
        this.state = ''
      }
    },
    async printHandler(isPre = false) {
      // 4:打印   5:预制
      if (!isPre) {
        this.saveType = 4
      }
      const job = this.currentRow
      const cargoDoc = await new AirExportJob(job).getCargoDoc(this.docType, false)
      if (!cargoDoc) {
        return
      }
      this.templateSelectorDialog.ctx = new AirExportJob(job)
      this.templateSelectorDialog.category = this.docType === CargoDocConsts.HAWB ? 'AEHAWB' : 'AEMAWB'
      this.templateSelectorDialog.data = { JOB_UUID: job.uuid, DOC_UUID: cargoDoc.uuid, cargoDocUuid: cargoDoc.uuid }
      this.templateSelectorDialog.prePrintCallback = async event => {
        if (!isPre) {
          this.saveType = 5
        }
        // CARGO-1484 空运出口-制单列表，主单预打印v2模板无法使用 v2||v3
        if (event.template && (event.template.engine === 1 || event.template.engine === 2)) {
          await StimulSoftUtil.stiReportPreview(event.template, job, event.parameter, 1, event.exportType)
        } else {
          await PrintTemplateManager.print(event.template, event.format, event.parameter, event.action === 'print')
        }
      }
      this.templateSelectorDialog.printedCallback = async event => {
        if (!isPre) {
          this.saveType = 5
        }
        const oldState = cargoDoc.state
        switch (this.saveType) {
          case 4:
          case 5:
            if (this.saveType === 4) {
              await this.fillModels()
            }
            if (this.saveType === 4 ? cargoDoc.state === 0 : true) {
              cargoDoc.state = 3
            }
            await updateAirCargoDoc(this.getSimpleCargoDoc(cargoDoc)).then(res => {
              Object.assign(cargoDoc, res.data)
              this.syncCargoDoc([cargoDoc])
              this.updateButtonState()
              this.$emit('callback')
            }).catch(() => {
              cargoDoc.state = oldState // 还原状态
            })
            break
          default:
            break
        }
      }
      this.templateSelectorDialog.visible = true
    },
    // 获取只含基本属性的cargoDoc
    getSimpleCargoDoc(cargoDoc) {
      const result = { ...cargoDoc }
      result.source = 'AePrepareDocument'
      delete result.afrAddress
      delete result.job
      return result
    },
    // 同步cargoDoc数据
    async syncCargoDoc(items) {
      const cargoDocs = await new AirExportJob(this.job).getAirCargoDoc()
      for (const item of items) {
        const cargoDoc = cargoDocs.find(p => p.uuid === item.uuid)
        if (cargoDoc) {
          Object.assign(cargoDoc, item)
        }
      }
    },
    async fillModels() {
      for (const item of this.pendTabSet) {
        if (typeof this.$refs[item].fillModel === 'function') {
          const result = this.$refs[item].fillModel()
          if (result instanceof Promise) {
            await result
          }
        }
      }
    },
    async rollbackPrintHandler() {
      const cargoDoc = await new AirExportJob(this.currentRow).getCargoDoc(this.docType, false)
      if (cargoDoc && cargoDoc.state === 3) {
        this.saveType = 6
        const oldState = cargoDoc.state
        cargoDoc.state = 5
        await updateAirCargoDoc(this.getSimpleCargoDoc(cargoDoc)).then(res => {
          Object.assign(cargoDoc, res.data)
          this.syncCargoDoc([cargoDoc])
          this.updateButtonState()
          this.$emit('callback')
        }).catch(() => {
          cargoDoc.state = oldState // 还原状态
        })
      }
    },
    async saveHandler() {
      await this.fillModels()
      this.saveType = 0
      /* 暂存时更新状态 */
      const cargoDoc = await new AirExportJob(this.currentRow).getCargoDoc(this.docType, false)
      const oldState = cargoDoc.state
      if (cargoDoc.state === 0) {
        cargoDoc.state = 1
      }
      await updateAirCargoDoc(this.getSimpleCargoDoc(cargoDoc)).then(res => {
        Object.assign(cargoDoc, res.data)
        this.syncCargoDoc([cargoDoc])
        this.updateButtonState()
        this.$emit('callback')
      }).catch(() => {
        cargoDoc.state = oldState
      })
    },
    async commitHandler() {
      await this.fillModels()
      /* 提交时更新状态 */
      const cargoDoc = await new AirExportJob(this.currentRow).getCargoDoc(this.docType, false)
      const oldState = cargoDoc.state
      if (cargoDoc.state < 3) {
        cargoDoc.state = 5
        this.saveType = 1
      } else if (cargoDoc.state === 5) {
        cargoDoc.state = 2
        this.saveType = 5
      }
      await updateAirCargoDoc(this.getSimpleCargoDoc(cargoDoc)).then(res => {
        Object.assign(cargoDoc, res.data)
        this.syncCargoDoc([cargoDoc])
        if (this.saveType === 1) {
          this.$message.success(this.$t('AirExport.SaveSuccessfully'))
        }
        this.updateButtonState()
        this.$emit('callback')
      }).catch(() => {
        cargoDoc.state = oldState
      })
    }
  }
}
</script>

<style scoped lang="scss">
.el-dialog__wrapper.billing-dialog ::v-deep .el-dialog {
  margin-top: 0 !important;
  margin-bottom: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  .el-dialog__body {
    overflow: hidden;
    padding: 0;
  }
}
</style>
